import newRestAPI from "./RestAPI";
import client from "./Client";

const restful = newRestAPI("/api/v1/spots");
const getSeshes = async (id) => {
  const { data } = await client.get(`/api/v1/spots/${id}/seshes`);
  return data;
};
const api = { ...restful, getSeshes };
export default api;
